module.exports = __webpack_public_path__ + "img/btn_before.ca87b34c.svg";